module.exports = __webpack_public_path__ + "static/media/letter.676e53b7.svg";